const PANEL_REDEMPTION_ORDER_PREFIX = "RC";
const PANEL_REDEMPTION_ORDER_TAG = "captify-admin-redemption";

export function isPanelRedemptionOrderId(value) {
  if (value == null || String(value).trim() === "") return false;
  return String(value)
    .trim()
    .toUpperCase()
    .startsWith(PANEL_REDEMPTION_ORDER_PREFIX);
}

export function isPanelRedemptionOrder(orderOrId) {
  if (orderOrId == null) return false;
  if (typeof orderOrId === "string" || typeof orderOrId === "number") {
    return isPanelRedemptionOrderId(orderOrId);
  }
  if (orderOrId.Tag === PANEL_REDEMPTION_ORDER_TAG) return true;
  return (
    isPanelRedemptionOrderId(orderOrId.ShopifyId) ||
    isPanelRedemptionOrderId(orderOrId.BackerID)
  );
}
